import React from "react";
import { useLocation } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import EmptyModule from "@/components/EmptyModule";
import { MODULE_META, NAV_GROUPS } from "@/config/navigation";

export default function ModulePage() {
    const location = useLocation();
    const key = location.pathname.replace("/", "").split("/")[0];
    const meta = MODULE_META[key] || { title: "Module", description: "" };

    const navItem = NAV_GROUPS.flatMap((g) => g.items).find((i) => i.path === `/${key}`);
    const Icon = navItem?.icon;

    return (
        <div data-testid={`page-${key}`}>
            <PageHeader title={meta.title} description={meta.description} />
            <EmptyModule moduleName={meta.title} icon={Icon} />
        </div>
    );
}
